import { Service } 		from "./../../Libs/Service";
import _ from "lodash";

import { Asset } 		from "./Asset";

let Settings = new Service({

	Name: "Settings",

	Events: {

		'Setting Control Additional Button Pressed': function(setting) {

			if (setting['codename'] === 'background-color') {

				let assets = Asset.getSelectedProjectMergedAssets();

				if (assets['background']) {

					let img = new Image();

					img.crossOrigin = "";
					img.onload = () => {

						this.setSettingValue(setting, this.getImageBorderColor(img));

					};

					img.src = assets['background']['url'];

				}

			}

		}

	},

	Actions: {

		'ProjectSettings': function(settings) {

			this.updateSettings(settings);

			Broadcast.call("Settings Changed", [settings]);

		},

		'TemplateGlobalSettings': function(templateGlobalSettings) {

			this.updateTemplateGlobalSettings(templateGlobalSettings);

			Broadcast.call("Template Global Settings Changed", [templateGlobalSettings]);

		},

		'SettingChanged': function(settingId) {

			Broadcast.call("Setting Changed", [this.Settings[settingId]]);

		},

		'GlobalSettingChanged': function(globalSettingId) {

			Broadcast.call("Global Setting Changed", [this.TemplateGlobalSettings[globalSettingId]]);

		},

		'VideoDownloadProgress': function (params) {
			Broadcast.call("Video Download Progress", [params.project, params.progress]);
		},

		"DoesVideoExistForProject": function (params) {

			Broadcast.call("Video Exists For Project", [params.projectId, params.exists]);

		},

		'UploadProgress': function(data, full_data) {

			Broadcast.call(`${full_data.UploadType} Upload Progress`, [full_data]);

		},

		'MultipleUploadProgress': function(data) {
			Broadcast.call("Multiple Upload Progress", [data]);
		},

		'AirbrakerFilter': function(params) {

			Broadcast.call('Airbraker Filtered IPs Received', [params.IPs]);

		}

	},

	init() {

		this.Settings = {};
		this.SettingsByProject = {};
		this.SettingsByProjectByCodename = {};

		this.TemplateGlobalSettings = {};
		this.TemplateGlobalSettingsByTemplate = {};
		this.TemplateGlobalSettingsByTemplateByCodename = {};

		this.ignoringTimeouts = {};

	},

	updateTemplateGlobalSettings(settings) {

		_.each(settings, setting => {

			this.TemplateGlobalSettings[setting.id] = setting;

			if (!this.TemplateGlobalSettingsByTemplate[setting.template_id]) this.TemplateGlobalSettingsByTemplate[setting.template_id] = {};
			this.TemplateGlobalSettingsByTemplate[setting.template_id][setting.id] = setting;

			if (!this.TemplateGlobalSettingsByTemplateByCodename[setting.template_id]) this.TemplateGlobalSettingsByTemplateByCodename[setting.template_id] = {};

			this.TemplateGlobalSettingsByTemplateByCodename[setting.template_id][setting.codename] = setting;

			if (setting.type === 'json' && typeof setting.value === 'string') {
				try {
					setting.value = JSON.parse(setting.value);
				} catch (e) {
					setting.value = {};
				}
			}

		});

	},

	updateSettings(settings) {

		let is_selected_project_settings_changed = false;

		_.each(settings, setting => {

			this.Settings[setting.id] = setting;

			if (!this.SettingsByProject[setting["project_id"]]) this.SettingsByProject[setting["project_id"]] = {};
			this.SettingsByProject[setting["project_id"]][setting.id] = setting;

			if (!this.SettingsByProjectByCodename[setting["project_id"]]) this.SettingsByProjectByCodename[setting["project_id"]] = {};
			this.SettingsByProjectByCodename[setting["project_id"]][setting.codename] = setting;

			//The type of value in database is string so ! is ok here.
			if (!setting["value"]) delete setting["value"];

			setting["value"] = this.getSettingValue(setting);

			setting.isChanged = this.isChangedSetting(setting);

			const settingValue = setting.value;

			let templateSetting = Metadata.TemplateSettingsByTemplateIdByCodename[setting["template_id"]][setting["codename"]];

			_.defaults(setting, templateSetting);
			setting.value = settingValue;


			if (setting.type === 'json' && typeof setting.value === 'string') {

				try {

					setting.value = JSON.parse(setting.value);

				} catch(e) {

					setting.value = {};

				}

			}

			if (Project.SelectedProject && setting["project_id"] === Project.SelectedProject.id) is_selected_project_settings_changed = true;

		});

		if (is_selected_project_settings_changed) Broadcast.call("Selected Project Settings Changed");

	},

	//Возвращаем настройки текущей версии проекта
	getSelectedProjectSettings() {

		if (!Template.SelectedTemplate) return null;

		//Настройки проекта
		if (Project.SelectedProject) {

			return _.values(this.SettingsByProject[Project.SelectedProject.id]);

		//Настройки по умолчанию для шаблона
		} else {

			return _.values(_.cloneDeep(Metadata.TemplateSettingsByTemplateId[Template.SelectedTemplate.id]));

		}

	},

	getSelectedProjectSettingsByCodename() {

		return _.keyBy(this.getSelectedProjectSettings(), 'codename');

	},

	getSettingValue(setting) {

		return setting["value"];

	},

	setSettingValue(setting, value) {

		value = this.fixSettingValue(setting, value);

		if (setting.codename === 'player-style') {
			let assetTop = Asset.AssetsByProjectByCodename[setting.project_id]['top'];
			let assetSide = Asset.AssetsByProjectByCodename[setting.project_id]['300x250'];

			if (value === '970x250') {
				if (assetTop) {
					Asset.enableAsset(assetTop);
				}
				if (assetSide) {
					Asset.disableAsset(assetSide);
				}
			} else if (value === '300x250') {
				if (assetSide) {
					Asset.enableAsset(assetSide);
				}
				if (assetTop) {
					Asset.disableAsset(assetTop);
				}
			} else if (value === 'docked-player') {
				if (assetTop) {
					Asset.disableAsset(assetTop);
				}
				if (assetSide) {
					Asset.disableAsset(assetSide);
				}
			}

			Broadcast.call('Preview Refresh');
		}

		this.saveSettingValue(setting, value);


		return value;

	},

	fixSettingValue(setting, value) {

		if (setting.type === 'number') value = parseFloat(value) || 0;

		return value;

	},

	saveSettingValue(setting, value) {

		Server.sendToSocket({
			SetSettingValue: {
				settingId: setting.id,
				value: value
			}
		});

	},

	saveTemplateGlobalSettingValue(setting, value) {
		Server.sendToSocket({
			SetTemplateGlobalSettingValue: {
				settingId: setting.id,
				value: value
			}
		})
	},

	setListSettingValue(setting, property_value, list_position) {

		let separator = ';';
		let list = setting.value.split(separator);

		if (list_position == null) {
			list.push(property_value);
		} else {
			list[list_position] = property_value;
		}

		list = list.filter((url) => this.isValidUrl(url));

		this.saveSettingValue(setting, list.join(separator));

		return property_value;

	},

	isValidUrl(url) {

		let pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
			'((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
			'(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
			'(\\#[-a-z\\d_]*)?$','i'); // fragment locator
		return !!pattern.test(url);

	},

	//Изменена ли настройка относительно того какое значение было изначально в шаблоне
	isChangedSetting(setting) {

		if (!setting) return true;
		if (!setting["template_id"]) return true;

		let templateSetting = Metadata.TemplateSettingsByTemplateIdByCodename[setting["template_id"]][setting["codename"]];

		if (!templateSetting) return true;

		return setting["value"] === templateSetting["value"];

	},

	ignoringTimeout(key, time, fn) {

		if (!this.ignoringTimeouts[key]) {

			this.ignoringTimeouts[key] = {

				Timeout: setTimeout(() => {

					this.ignoringTimeouts[key].func();

					this.ignoringTimeouts[key] = null;

				}, time),

				func: fn

			};

		} else {

			this.ignoringTimeouts[key].Func = fn;

		}

	},

	getImageBorderColor(img, border = 1) {

		let canvas = document.createElement("canvas"),  // create a canvas element
			ctx = canvas.getContext("2d"),              // get context
			w = img.naturalWidth,                       // get actual width..
			h = img.naturalHeight;

		canvas.width = w;                               // set canvas size
		canvas.height = h;

		ctx.drawImage(img, 0, 0);                       // draw in image

		// do checks:, for example:
		//if (border*2 > canvas.width || border*2 > canvas.height) throw "Image too small!";

		// get borders, avoid overlaps (though it does not really matter in this case):
		//let top = ctx.getImageData(0, 0, w, border).data;
		//let left = ctx.getImageData(0, border, border, h - border * 2).data;
		//let right = ctx.getImageData(w - border, border, border, h - border * 2).data;
		let bottom = ctx.getImageData(0, h - border, w, border).data;

		let r = 0, g = 0, b = 0, cnt = 0;

		// count pixels and add up color components: (see function below)
		//countBuffer(top);
		//countBuffer(left);
		//countBuffer(right);
		countBuffer(bottom);

		// calc average
		r = (r / cnt + 0.5) | 0;
		g = (g / cnt + 0.5) | 0;
		b = (b / cnt + 0.5) | 0;

		return rgbToHex(r, g, b);

		function countBuffer(data) {
			let i = 0, len = data.length;
			while (i < len) {
				r += data[i++];   // add red component etc.
				g += data[i++];
				b += data[i++];
				i++;
				cnt++;            // count one pixel
			}
		}

		function componentToHex(c) {
			let hex = c.toString(16);
			return hex.length === 1 ? "0" + hex : hex;
		}

		function rgbToHex(r, g, b) {
			return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
		}

		alert(rgbToHex(0, 51, 255)); // #0033ff

	}

});

//Делаем глобальную ссылку для дебага - чтобы в консоли был виден этот объект сразу
window.Settings = Settings;

export { Settings }

